import { createStyles } from "@mantine/emotion";

export const useStylesPage = createStyles((theme) => ({
  page: {
    paddingBottom: theme.spacing.page.paddingBottom,
    color: theme.customColors.black,
    background: theme.customBackgrounds.page,
    flexDirection: "column",
    position: "relative",
    [`@media (min-width: ${theme.breakpoints.mobileMin})`]: {
      width: "100%",
    },
    [`@media (max-height: ${theme.breakpoints.heightMax})`]: {
      justifyContent: "center",
    },
    ".mantine-Accordion-item": {
      marginTop: "1.4em !important",
    },
  },
  pageHeaderIcon: {
    width: "4.8em",
    marginLeft: "auto",
    marginRight: "auto",
  },
  pageUserFound: {
    width: "100%",
    ".container": {
      width: "calc(100% - 2.8em)",
      maxWidth: "74em",
      marginLeft: "auto",
      marginRight: "auto",
    },
    ".user-found-loader-wrap": {
      minHeight: "25em",
    },
  },
  pageCollectionFound: {
    paddingTop: "2.5em",
    position: "relative",
    width: "100%",
    height: "100%",
    [`@media (min-width: ${theme.breakpoints.mobileMin})`]: {
      paddingTop: "0",
    },
    ".header-wrap": {
      textAlign: "center",
    },
    h1: {
      fontSize: "2.54em",
    },
    ".alert": {
      background: "none",
      paddingLeft: "0",
      paddingRight: "0",
    },
  },
  header: {
    width: "100%",
    textAlign: "center",
    position: "relative",
    maxWidth: "67em",
  },
  headerTitle: {
    fontFamily: theme.headings.fontFamily.secondary,
    fontSize: theme.spacing.page.header.title.fontSize.default,
    lineHeight: theme.spacing.page.header.title.lineHeight.default,
    textAlign: "center",
    marginTop: "0",
    marginBottom: theme.spacing.page.header.title.marginBottom.default,

    [`@media (min-width: ${theme.breakpoints.mobileMin})`]: {
      fontSize: theme.spacing.page.header.title.fontSize.desktop,
      lineHeight: theme.spacing.page.header.title.lineHeight.desktop,
      marginBottom: theme.spacing.page.header.title.marginBottom.desktop,
      marginTop: "2em",
    },
    span: {
      fontWeight: "bold",
      fontSize: "1em",
    },
  },
  stampTitleBrand: {
    whiteSpace: "nowrap",
    sup: {
      color: "inherit",
      fontFamily: theme.fontFamily.secondary,
      fontSize: theme.spacing.page.header.title.registeredMark.fontSize,
      lineHeight: 0,
      verticalAlign: "super",
    },
  },
  headerTitleSpecial: {
    marginTop: "0",

    [`@media (min-width: ${theme.breakpoints.mobileMin})`]: {
      marginTop: "7em",
    },
  },
  headerText: {
    fontFamily: theme.headings.fontFamily.primary,
    fontSize: theme.spacing.page.header.text.fontSize.default,
    lineHeight: theme.spacing.page.header.text.lineHeight.default,
    color: theme.customColors.black,
    marginLeft: "auto",
    marginRight: "auto",
    textAlign: "center",
    paddingLeft: "1em",
    paddingRight: "1em",
    minHeight: "3em",
    [`@media (min-width: ${theme.breakpoints.mobileMin})`]: {
      fontSize: theme.spacing.page.header.text.fontSize.desktop,
      lineHeight: theme.spacing.page.header.text.lineHeight.desktop,
    },
  },
  headerTextNoHeight: {
    minHeight: "auto",
  },
  screen: {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    height: "100%",
    paddingTop: theme.spacing.page.screen.paddingTop.default,
    position: "relative",
    width: "100%",
    [`@media (min-width: ${theme.breakpoints.mobileMin})`]: {
      paddingTop: theme.spacing.page.screen.paddingTop.desktop,
    },
    ".icon-tabler-device-floppy": {
      fill: "#fff",
      stroke: "#000",
      strokeWidth: "0.09em",
    },
    "button.active": {
      ".icon-tabler-device-floppy": {
        fill: "none",
        stroke: "#fff",
      },
    },
    ".svg-stamp-from-text": {
      marginRight: "0.65em",
    },
    ".svg-stamp-from-portfolio": {
      marginRight: "0.7em",
    },
  },
  errorMessage: {
    color: theme.customColors.red,
    fontFamily: theme.headings.fontFamily.light,
  },
  manyStamps: {
    border: "1px solid " + theme.customColors.greenTooltip,
    backgroundColor: theme.customBackgrounds.infoBlock,
    fontFamily: theme.headings.fontFamily.light,
    marginTop: "2em",
    width: "100%",
    marginBottom: "-2em",
    textAlign: "center",
    fontSize: "0.9em",
    lineHeight: "1.1em",
    paddingTop: "0.8em",
    paddingBottom: "0.8em",
    marginLeft: "1.5em",
    marginRight: "1.5em",
    maxWidth: "calc(100% - 3em)",

    [`@media (min-width: ${theme.breakpoints.mobileMin})`]: {
      width: "auto",
      marginBottom: "1.1em",
      fontSize: "1.1em",
      lineHeight: "1.5em",
      padding: "0.6em 2.1em",
      maxWidth: "30em",
      marginLeft: "auto",
      marginRight: "auto",
    },
    a: {
      padding: "0",
    },
  },
  timestampsMatch: {
    fontFamily: theme.headings.fontFamily.primary,
  },
}));
